//#region src/components/ui/pagination/locale/en_US.ts
var e = {
	detail: "Showing {{pageStart}}-{{pageEnd}} of {{total}} items",
	first: "First",
	previous: "Previous",
	next: "Next",
	last: "Last",
	morePages: "More pages",
	page: "{{page}} / page",
	goTo: "Go to",
	goToPage: "Page"
};
//#endregion
export { e as paginationLocale };

//# sourceMappingURL=en_US.js.map